import { render, staticRenderFns } from "./CandidateListFilters.vue?vue&type=template&id=5c963903&"
import script from "./CandidateListFilters.vue?vue&type=script&lang=js&"
export * from "./CandidateListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports